import { HTTPService as Srv } from '@services';

export const $news_fetchAll = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ from = 0 || null, to = 0 || null, ...body }, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('news/fetch/all', {
				from,
				to,

				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $news_fetchAllContent = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ from = 0 || null, to = 0 || null, ...body }, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('news/fetch/all/content', {
				from,
				to,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $news_fetchById = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ id = 0 || null, ...body }, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('news/fetch/id', {
				id,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $news_save = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{
		title = '' || null,
		content = '' || null,
		image = '' || null,
		activefrom = '' || null,
		activeto = '' || null,
		// user_id = 0 || null,
		...body
	}, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('news/save', {
				title,
				content,
				image,
				activefrom,
				activeto,
				// user_id,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $news_edit = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{
		id = 0 || null,
		title = '' || null,
		content = '' || null,
		image = '' || null,
		activefrom = '' || null,
		activeto = '' || null,
		isvisible = '' || null,
		// user_id = 0 || null,
		...body
	}, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('news/edit', {
				id,
				title,
				content,
				image,
				activefrom,
				activeto,
				isvisible,
				// user_id,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $news_delete = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ id = 0 || null, ...body }, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('news/delete', {
				id,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});
